import React, { useState, useEffect } from 'react';
import '../../assets/css/SplashScreen.css';
import Logo from '../../assets/img/geohcx_logo_splash.png';

const SplashScreen = () => {

    const messages = [
        'Cargando base de datos',
        'Cargando los mapas de geolocalización',
        'Cargando todos los usuarios',
        'Cargando toda la información de la plataforma Digital GEOHCX.',
        'Finalizando la carga de todos los datos, dejando todo listo.'
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {

        const interval = setInterval(() => {

            setIndex((prev) => {
                if (prev < messages.length - 1) {
                    return prev + 1;
                }
                return prev;
            });

        }, 1000);

        return () => clearInterval(interval);

    }, []);

    return (
        <div className="splash-screen">

            <img src={Logo} alt="GEOHCX Logo" className="splash-logo" />

            <h1 className="splash-title">Bienvenido a GEOHCX</h1>

            <h2 className="splash-subtitle">
                Plataforma Digital para el Monitoreo, Registro y Alerta de Infecciones por Geohelmintos en Humanos en el departamento de Córdoba.
            </h2>

            <p className="splash-description">
                Fortalecimiento del Sistema Territorial de Ciencia, Tecnología e Innovación soportado en la Transformación Digital e Industrias 4.0 en el departamento de Córdoba – BPIN 2021000100455.
            </p>

            <div className="progress-container">
                <div className="progress-bar-animated"></div>
            </div>

            {/* MENSAJE DINÁMICO */}
            <div className="loading-message">
                {messages[index]}
                <span className="dots"></span>
            </div>

            <small className="mt-3 text-muted fw-bold">Cargando servicios...</small>

        </div>
    );
};

export default SplashScreen;
